import CommonService from "@/commons/services/CommonService";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * ### 郵便番号から住所検索 API 操作クラス
 *
 * - zipcloudの定常しているAPIにリクエストして郵便番号から住所を取得する
 * - http://zipcloud.ibsnet.co.jp/doc/api
 */
export default class Zipcloud {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * ### 郵便番号から住所検索
   */
  public async get(postalCode: string): Promise<ZipcloudGetModel> {
    const requestUrl: string = `https://zipcloud.ibsnet.co.jp/api/search?zipcode=${postalCode}&limit=1`;
    const response = await this.commonService.executeSimpleGet<ZipcloudGetModel>(requestUrl, this.constructor.name, {}, HitomeqErrorType.REQUEST_RETRY);

    return response.data;
  }
}

export interface ZipcloudGetModel {
  /** ステータスコード */
  status: number;
  /** メッセージ */
  message: string | null;
  /** 検索結果。複数該当することがあるため、配列で返却される */
  results: Array<ZipcloudAddress> | null;
}

export interface ZipcloudAddress {
  /** 7桁の郵便番号。ハイフンなし */
  zipcode: string;
  /** JIS X 0401 に定められた2桁の都道府県コード */
  prefcode: string;
  /** 都道府県名 */
  address1: string;
  /** 市区町村名 */
  address2: string;
  /** 町域名 */
  address3: string;
  /** 都道府県名カナ */
  kana1: string;
  /** 市区町村名カナ */
  kana2: string;
  /** 町域名カナ */
  kana3: string;
}
